import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/footerlogo.svg';
import youtubeIcon from '../assets/YoutubeLogo.svg';
import instagramIcon from '../assets/InstagramLogo.svg';
import facebookIcon from '../assets/FacebookLogo.svg';
import twitterIcon from '../assets/XLogo.svg';

const styles = `
.footer {
  background: #F0F7FF;
  padding: 4rem 1rem;
  font-family: 'Titillium Web', sans-serif;
  color: #111;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.4fr 2.6fr;
  gap: 2rem;
  align-items: flex-start;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-left: -90px;
}

.footer-brand img {
  width: 140px;
  margin-bottom: 1rem;
}

.footer-brand p {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
  max-width: 320px;
}

.footer-socials {
  display: flex;
  gap: 1.2rem;
  justify-content: center;
}

.footer-socials img {
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.footer-links-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 3rem;
}

.footer-links {
  display: flex;
  flex-direction: column;
}

.footer-links h4 {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 2.4rem;
  color: #000;
}

.footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 1rem;
}

.footer-links a {
  text-decoration: none;
  color: #444;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #27409C;
}

/* Tablets */
@media (max-width: 992px) {
  .footer-inner {
    grid-template-columns: 1fr;
    text-align: left;
  }

  .footer-brand {
    align-items: center;
    margin-left: 0;
    margin-bottom: 2rem;
    text-align: center;
  }

  .footer-socials {
    justify-content: center;
  }

  .footer-links-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
}

/* Phones */
@media (max-width: 600px) {
  .footer-brand p {
    text-align: center;
  }

  .footer-socials {
    justify-content: center;
  }

  .footer-links-wrapper {
    align-items: flex-start;
  }

  .footer-links {
    align-items: flex-start;
  }
}
`;

const creditCards = [
  'Cashback Cards',
  'Reward Cards',
  'Travel Cards',

  
  'Lifestyle Cards',
  'Fuel Cards',
];

const Pages = [
  { label: 'Partner Banks', path: '/partner-banks' },
  { label: 'Credit Cards', path: '/credit-cards' },
  { label: 'Blogs', path: '/offers-news' },
  { label: 'Smart Assistant', path: '/smart-assistant' },
  { label: 'Calculators', path: '/calculators' },
  { label: 'Consultation', path: '/consultation' },
];
const companyLinks = [
  { label: 'About Us', path: '/about-us' },
  { label: 'Contact', path: '/contact' },
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms of Service', path: '/terms-of-service' },
  { label: 'Advertiser Disclosure', path: '/advertiser-disclosure' },
];

// const company = [
//   'About Us',
//   'Contact',
//   'Privacy Policy',
//   'Terms of Service',
//   'Advertiser Disclosure',
// ];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <>
      <style>{styles}</style>
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src={logo} alt="Card Academy logo" />
            <p>Your educational platform for credit cards, financial knowledge, and expert advice.</p>
            <div className="footer-socials">
              <a href="https://www.youtube.com/@CardAcademy" target="_blank" rel="noopener noreferrer">
                <img src={youtubeIcon} alt="YouTube" />
              </a>
              <a href="https://www.instagram.com/card.academy/" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} alt="Instagram" />
              </a>
              <a href="https://www.facebook.com/card.academy" target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} alt="Facebook" />
              </a>
              <a href="https://x.com/CardAcadem77706" target="_blank" rel="noopener noreferrer">
                <img src={twitterIcon} alt="X" />
              </a>
            </div>
          </div>

          <div className="footer-links-wrapper">
            <div className="footer-links">
              <h4>CREDIT CARDS</h4>
              <ul>
                {creditCards.map((item, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate('/credit-cards', { state: { selectedTab: item } });
                      }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <h4>PAGES</h4>
              <ul>
                {Pages.map((item, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.path);
                      }}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <h4>COMPANY</h4>
              <ul>
  {companyLinks.map((item, index) => (
    <li key={index}>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          navigate(item.path);
        }}
      >
        {item.label}
      </a>
    </li>
  ))}
</ul>

            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
